import "../news-search.css";

const SHOW = "Bigg Boss Malayalam";
const GOOGLE_NEWS_RSS_URL = "https://news.google.com/rss/search?q=";
const RSS2JSON_URL = "https://api.rss2json.com/v1/api.json";
const STORAGE_KEY = "bb_malayalam_browser_news_v2";
const SEARCH_CACHE_KEY = "bb_malayalam_browser_news_search_v2";
const FALLBACK_IMAGE = "https://placehold.co/1280x720/101323/F5F7FF?text=Bigg+Boss+Malayalam";

const seeds = [
  { id: "bbm8-launch", slug: "bigg-boss-malayalam-8-launch", title: "Bigg Boss Malayalam 8 opens with a 21-member house", category: "Season 8", date: "2026-09-10", source: "Times of India", sourceUrl: "https://timesofindia.indiatimes.com/tv/news/malayalam/bigg-boss-malayalam-8-contestants-list-with-photos-confirmed-list-of-contestants-of-bigg-boss-malayalam-8-mohanlal/photostory/133803153.cms", excerpt: "Bigg Boss Malayalam Season 8 launched with 21 contestants and a new Democracy theme, bringing celebrities, creators and Agnipareeksha selections into the house.", image: FALLBACK_IMAGE },
  { id: "bbm8-democracy", slug: "bigg-boss-malayalam-8-democracy", title: "Bigg Boss Malayalam 8 introduces the Democracy theme", category: "Season 8", date: "2026-09-06", source: "Times of India", sourceUrl: "https://timesofindia.indiatimes.com/tv/news/malayalam/from-host-mohanlals-dashing-avatar-to-the-first-ever-democracy-room-heres-everything-about-bigg-boss-malayalam-8/photostory/133827494.cms", excerpt: "The new season centres on a democracy-themed format and a dedicated democracy room, giving the house a different decision-making structure.", image: FALLBACK_IMAGE },
  { id: "bbm8-wildcard", slug: "tashi-shibna-wildcard-buzz", title: "Tashi and Shibna linked to Bigg Boss Malayalam 8 wildcard buzz", category: "House Buzz", date: "2026-09-12", source: "Times of India", sourceUrl: "https://timesofindia.indiatimes.com/tv/news/malayalam/bigg-boss-malayalam-8-tashi-and-shibna-set-to-enter-as-wildcard-contestants/articleshow/134136490.cms", excerpt: "Reports are discussing Tashi and Shibna as possible wildcard entrants after the opening week of Season 8.", image: FALLBACK_IMAGE },
];

function clean(v = "") {
  return String(v).replace(/<[^>]*>/g, " ").replace(/\s+/g, " ").trim();
}

function slugify(v = "") {
  return clean(v).toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "").slice(0, 100) || `news-${Date.now()}`;
}

function load(key) {
  try {
    const value = localStorage.getItem(key);
    return value ? JSON.parse(value) : null;
  } catch {
    return null;
  }
}

function save(key, value) {
  try {
    localStorage.setItem(key, JSON.stringify(value));
  } catch {}
}

function mapItem(item, i) {
  const title = clean(item?.title || "");
  const sourceUrl = clean(item?.link || "");
  const dateValue = item?.pubDate ? new Date(item.pubDate) : new Date();
  return {
    id: `rss-${i}-${slugify(title)}`,
    slug: `rss-${slugify(title)}`,
    title,
    category: "Latest News",
    date: Number.isNaN(dateValue.getTime()) ? new Date().toISOString().slice(0, 10) : dateValue.toISOString().slice(0, 10),
    source: clean(item?.author || item?.source || "Google News") || "Google News",
    sourceUrl,
    excerpt: clean(item?.description || item?.content || ""),
    image: FALLBACK_IMAGE,
  };
}

const stored = typeof window !== "undefined" ? load(STORAGE_KEY) : null;
export const newsArticles = Array.isArray(stored) && stored.length ? stored : seeds;
export const articleCategories = ["All", "Latest News", "Season 8", "House Buzz"];

function buildGoogleRssUrl(searchQuery = "") {
  const query = clean(searchQuery);
  const text = query ? `${SHOW} ${query}` : SHOW;
  // Use + separators in the Google query itself. This avoids nested percent encoding
  // such as %2520 when the complete RSS URL is escaped for rss2json.
  const googleQuery = text.split(/\s+/).filter(Boolean).join("+");
  return `${GOOGLE_NEWS_RSS_URL}${googleQuery}&hl=en-IN&gl=IN&ceid=IN:en`;
}

function buildRss2JsonRequest(rssUrl) {
  const requestUrl = new URL(RSS2JSON_URL);
  requestUrl.searchParams.set("rss_url", rssUrl);
  return requestUrl.toString();
}

export async function refreshNewsFromGoogleInBrowser(searchQuery = "") {
  if (typeof window === "undefined" || typeof window.fetch !== "function") return null;

  const q = clean(searchQuery).toLowerCase();
  const key = q || "__default__";
  const cache = load(SEARCH_CACHE_KEY) || {};

  if (Array.isArray(cache[key]) && cache[key].length) {
    newsArticles.splice(0, newsArticles.length, ...cache[key]);
    window.dispatchEvent(new CustomEvent("bigg-boss-news-updated", { detail: newsArticles }));
    return newsArticles;
  }

  try {
    const rssUrl = buildGoogleRssUrl(searchQuery);
    const requestUrl = buildRss2JsonRequest(rssUrl);
    const response = await window.fetch(requestUrl, {
      method: "GET",
      mode: "cors",
      credentials: "omit",
      headers: { Accept: "application/json" },
    });

    if (!response.ok) throw new Error(`rss2json HTTP ${response.status}`);

    const data = await response.json();
    if (data?.status && data.status !== "ok") throw new Error(data.message || "Feed rejected");

    const next = Array.isArray(data?.items)
      ? data.items.map(mapItem).filter((article) => article.title && article.sourceUrl)
      : [];

    if (!next.length) throw new Error("No usable articles");

    newsArticles.splice(0, newsArticles.length, ...next);

    cache[key] = next;
    const keys = Object.keys(cache);
    while (keys.length > 12) delete cache[keys.shift()];
    save(SEARCH_CACHE_KEY, cache);
    if (!q) save(STORAGE_KEY, next);

    window.dispatchEvent(new CustomEvent("bigg-boss-news-updated", { detail: next }));
    return next;
  } catch (error) {
    console.warn("Bigg Boss Malayalam news refresh failed", error);
    return newsArticles;
  }
}
